import * as React from "react";
import moment from "moment";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { UncontrolledDropdown, DropdownMenu, DropdownItem, DropdownToggle } from 'reactstrap';
import { get } from "lodash";
import { getGeoApi } from "../api/geo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Can from "../auth/Can";
import roles from "../auth/roles";

export const DropdownFilterElement = ({ field, type, options, onChange }) => {
    const [filterValue, setFilterValue] = React.useState();

    return (
        <Dropdown
            filter
            filterBy="label"
            className="p-column-filter"
            showClear={true}
            style={{ width: "100%" }}
            appendTo={document.body}
            value={filterValue || ""}
            options={options}
            onChange={e => {
                setFilterValue(e.value);
                onChange && onChange({
                    value: e.value,
                    field,
                    type
                });
            }}
        />
    );
}

export function getDateTime(rowData, column) {
    const dateString = get(rowData, column.field);
    if (!dateString) return "";
    return moment(dateString).format("DD/MM/YYYY HH:mm:ss");
}

export function filterDateTime(dateString, filter) {
    if (!dateString) return "";
    const datestr = moment(dateString).format("DD/MM/YYYY HH:mm:ss");
    return datestr.startsWith(filter);
}

export function getDate(rowData, column) {
    const dateString = get(rowData, column.field);
    if (!dateString) return "";
    return moment(dateString).format("DD/MM/YYYY");
}

export function filterDate(dateString, filter) {
    if (!dateString) return "";
    const datestr = moment(dateString).format("DD/MM/YYYY");
    return datestr.startsWith(filter);
}

export function getRegion(rowData) {
    const geo = getGeoApi();
    return geo.getRegioneLabel(rowData.address.region);
}

export function getCity(rowData) {
    const geo = getGeoApi();
    return geo.getComuneLabel(rowData.address.city);
}

export function renderHeader(loading, totResults, headerTitle, left, globalFilterOpts, exportTable) {
    globalFilterOpts = globalFilterOpts || { globalFilter: undefined, setGlobalFilter: () => null, onRefresh: () => null }

    return (
        <div className="p-clearfix" style={{ lineHeight: "1em" }}>
            {left && (
                <div style={{ float: "left" }}>{left}</div>
            )}
            {headerTitle}
            <Button
                disabled={loading}
                label={!loading ? totResults.toString() : null}
                onClick={globalFilterOpts.onRefresh}
                icon={loading ? "pi pi-spin pi-spinner" : ""}
                style={{ float: "right" }}
            />
            <div className="p-inputgroup mr-2" style={{ float: "right" }}>
                <InputText value={globalFilterOpts.globalFilter || ""} type="search" className="p-datatable-globalfilter-container" onChange={(e) => globalFilterOpts.setGlobalFilter(e.target.value)} placeholder="Ricerca globale" size="24" />
                <Button icon="pi pi-search" className="p-button-info" />
                <Can
                    roles={[roles.ADMIN]}
                    yes={() => (
                        <UncontrolledDropdown tag="span" className="ml-2">
                            <DropdownToggle color="secondary" caret size="md">
                                <FontAwesomeIcon icon="external-link-alt" />
                            </DropdownToggle>
                            <DropdownMenu>
                                <div role="menuitem"><a className="dropdown-item" href="#/" onClick={exportTable}>Esporta CSV</a></div>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    )}
                    no={() => null}
                />
            </div>
        </div>
    );
};
